/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Confirm_RejectInputs */

const en_admin_membership_confirmations_confirm_reject = /** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to reject this member and delete all their data?`)
};

const nl_admin_membership_confirmations_confirm_reject = /** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weet je zeker dat je dit lid wilt afwijzen en al hun gegevens wilt verwijderen?`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const de_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const es_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const fr_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const it_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const pl_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const hu_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_RejectInputs) => LocalizedString} */
const ro_admin_membership_confirmations_confirm_reject = en_admin_membership_confirmations_confirm_reject;

/**
* | output |
* | --- |
* | "Are you sure you want to reject this member and delete all their data?" |
*
* @param {Admin_Membership_Confirmations_Confirm_RejectInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_confirm_reject = /** @type {((inputs?: Admin_Membership_Confirmations_Confirm_RejectInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Confirm_RejectInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "de") return de_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "es") return es_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "it") return it_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_confirm_reject(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_confirm_reject(inputs)
	return ro_admin_membership_confirmations_confirm_reject(inputs)
});
export { admin_membership_confirmations_confirm_reject as "admin.membership_confirmations.confirm_reject" }